export type QuestStatus = 'locked' | 'active' | 'completed';

export interface Quest {
  id: string;
  zone: number;
  title: string;
  description: string;
  status: QuestStatus;
  maxProgress: number;
  progress: number;
}

export const ZONE1_QUEST_ORDER = [
  'zone1_read_sign',
  'zone1_meet_kakek',
  'zone1_collect_rafflesia',
  'zone1_to_forest',
] as const;

export const ZONE2_QUEST_ORDER = [
  'zone2_enter_forest',
  'zone2_watch_animals',
  'zone2_find_keris1',
  'zone2_read_keris1',
  'zone2_survive_earthquake',
  'zone2_to_zone3',
] as const;

export const ZONE3_QUEST_ORDER = [
  'zone3_arrive',
  'zone3_find_keris2',
  'zone3_emergency_bag',
  'zone3_to_zone4',
] as const;

export const ZONE4_QUEST_ORDER = [
  'zone4_find_keris3',
  'zone4_read_keris3',
  'zone4_meet_guide',
  'zone4_read_sign',
  'zone4_safe_route',
  'zone4_to_zone5',
] as const;

export const ZONE5_QUEST_ORDER = [
  'zone5_go_safe_zone',
  'zone5_meet_vulnerable',
  'zone5_choose_action',
  'zone5_escort_safe',
  'zone5_meet_ibundo',
] as const;

export const QUESTS: Quest[] = [
  {
    id: 'zone1_read_sign',
    zone: 1,
    title: 'Baca Papan Petunjuk 1',
    description: 'Baca papan petunjuk misi di awal perjalanan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone1_meet_kakek',
    zone: 1,
    title: 'Temui Kakek Sakti',
    description: 'Temui Kakek Sakti untuk mendapatkan petunjuk rahasia mengenai lokasi Keris Pusaka.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone1_collect_rafflesia',
    zone: 1,
    title: 'Ambil Rafflesia Point',
    description: 'Ambil petunjuk pertama dari bunga Rafflesia.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone1_to_forest',
    zone: 1,
    title: 'Menuju Hutan',
    description: 'Masuk jalur hutan menuju Zona 2: Hutan Berguncang.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_enter_forest',
    zone: 2,
    title: 'Masuki Hutan',
    description: 'Masuk lebih dalam ke hutan dan siapkan diri membaca tanda alam.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_watch_animals',
    zone: 2,
    title: 'Perhatikan Tanda Alam',
    description: 'Dekati papan tanda alam (kiri), tekan E atau otomatis saat dekat.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_find_keris1',
    zone: 2,
    title: 'Temukan Keris 1',
    description: 'Jalan ke kanan, dekat Keris 1, tekan E untuk mengambil.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_read_keris1',
    zone: 2,
    title: 'Baca Petunjuk Keris 1',
    description: 'Tekan E di tempat Keris 1 untuk baca petunjuk BMKG.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_survive_earthquake',
    zone: 2,
    title: 'Selamat dari Gempa',
    description: 'Hindari pohon tumbang dan retakan tanah selama 30 detik.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone2_to_zone3',
    zone: 2,
    title: 'Lanjut ke Rumah Bubungan',
    description: 'Ke ujung kanan peta, tekan E untuk masuk Zona 3.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone3_arrive',
    zone: 3,
    title: 'Tiba di Rumah Bubungan Lima',
    description: 'Masuk ke area Rumah Kebun dan mulai persiapan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone3_find_keris2',
    zone: 3,
    title: 'Temukan Keris 2',
    description: 'Cari Keris 2 di halaman depan rumah bubungan (area kiri).',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone3_emergency_bag',
    zone: 3,
    title: 'Siapkan Tas Darurat',
    description: 'Pilih 10 item wajib yang harus dibawa sesuai panduan BNPB.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone3_to_zone4',
    zone: 3,
    title: 'Lanjut ke Persimpangan',
    description: 'Menuju persimpangan jalur aman di Zona 4.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_find_keris3',
    zone: 4,
    title: 'Temukan Keris 3',
    description: 'Cari Keris 3 di persimpangan jalur.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_read_keris3',
    zone: 4,
    title: 'Baca Petunjuk Keris 3',
    description: 'Pelajari petunjuk terakhir dari Keris Pusaka.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_meet_guide',
    zone: 4,
    title: 'Temui Petugas Evakuasi',
    description: 'Datangi petugas di persimpangan dan dengarkan arahannya.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_read_sign',
    zone: 4,
    title: 'Baca Papan Petunjuk',
    description: 'Ikuti arahan petugas — baca papan petunjuk di persimpangan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_safe_route',
    zone: 4,
    title: 'Pilih Jalur Evakuasi',
    description: 'Pilih jalur yang paling tepat saat terjadi gempa di perbukitan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone4_to_zone5',
    zone: 4,
    title: 'Lanjut Bantu Warga',
    description: 'Menuju jalur evakuasi untuk membantu warga.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_go_safe_zone',
    zone: 5,
    title: 'Menuju Titik Aman',
    description: 'Berjalan menuju lapangan terbuka / titik kumpul aman.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_meet_vulnerable',
    zone: 5,
    title: 'Temui Warga Rentan',
    description: 'Datangi lansia dan ibu hamil, dengarkan cerita mereka.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_choose_action',
    zone: 5,
    title: 'Pilih Tindakan',
    description: 'Putuskan apakah akan membantu warga rentan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_escort_safe',
    zone: 5,
    title: 'Antar ke Zona Aman',
    description: 'Bantu warga rentan menuju titik kumpul aman.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_panic_path',
    zone: 5,
    title: 'Panik — lari ke Ibundo',
    description: 'Tidak membantu warga rentan.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
  {
    id: 'zone5_meet_ibundo',
    zone: 5,
    title: 'Temui Ibundo Putri Rimas',
    description: 'Temui Ibundo Putri Rimas di ujung ladang.',
    status: 'locked',
    maxProgress: 1,
    progress: 0,
  },
];

export function getQuestsByZone(zone: number): Quest[] {
  return QUESTS.filter((q) => q.zone === zone);
}

export function getZoneQuestOrder(zone: number): readonly string[] | null {
  switch (zone) {
    case 1:
      return ZONE1_QUEST_ORDER;
    case 2:
      return ZONE2_QUEST_ORDER;
    case 3:
      return ZONE3_QUEST_ORDER;
    case 4:
      return ZONE4_QUEST_ORDER;
    case 5:
      return ZONE5_QUEST_ORDER;
    default:
      return null;
  }
}
